import axios from "../../axios"

const header = (token) => {
  return {
    headers: {
        Authorization: "Bearer " + token
    }
  }
}

export default {
  async fetch(email, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/permission/email';
    try {

      return await axios.get('',  {
        params: {
          email: email
        },
        ...header(token)
      });

    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async fetchAll(token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/permission';
    try {

      return await axios.get('', header(token));

    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async fetchAllWithCategories(token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/permission/categories';
    try {

      return await axios.get('', header(token));

    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  },
  async updatePermission(token, roleId, permissions) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/permission/update';
    try {

      return await axios.post('', {
        roleId: roleId,
        permissions: permissions
      }, header(token));

    } catch (Exception) {
      console.log(Exception);
      throw Exception;
    }
  }
}